<div class="maps">
  <div class="row m-0">
    <div class="col-12 d-md-none m-0 p-0">
      <div class="mob-search">
        <div class="search-opt">
          <button type="button" (click)="categoryPanel.toggle($event)">
            <span class="selected-category"><i class="icon-location"></i>{{ selectedCat.name | translate }}</span>
            <span class="fas fa-caret-down mobiledownarrow"></span>
          </button>
        </div>
        <div class="close-icon">
          <i class="pi pi-times closeicon" (click)="navigateToHome()"></i>
        </div>
      </div>
    </div>

    <div class="col-12 d-md-none m-0 p-0" style="position: absolute; top: 80px; z-index: 999">
      <div class="mob-search-panel" style="float: right">
        <button
          *ngIf="!showMobileSearch"
          (click)="showSearch()"
          pButton
          pRipple
          type="button"
          icon="pi pi-search"
          class="p-button-rounded black-icon"
          aria-label="Open search"
        ></button>
        <!-- <i class="icon icon-search-light mob-search-icon" (click)="showSearch()" *ngIf="!showMobileSearch"></i>
        <i class="pi pi-times mob-search-icon-close" (click)="showSearch()" *ngIf="showMobileSearch"></i> -->
      </div>
      <div class="mob-search-panel-auto" *ngIf="showMobileSearch" style="margin-right: 10px; margin-left: 10px">
        <p-autoComplete
          [(ngModel)]="searchTxt"
          [suggestions]="newserachResults"
          minLength="3"
          (onSelect)="getSearchDetails($event)"
          (completeMethod)="search($event)"
        ></p-autoComplete>
        <i class="icon pi pi-times close-mobile-search" (click)="showSearch()"></i>
      </div>
    </div>
    <div class="col-md-3 d-none d-md-block m-0 p-0 categories">
      <ng-container *ngTemplateOutlet="categoryOptions"></ng-container>
    </div>
    <div class="col-md-9 m-0 p-0 map-container">
      <div class="d-none d-md-block">
        <div class="search-panel">
          <button
            *ngIf="!showSearchBox"
            (click)="openSearchBox()"
            pButton
            pRipple
            type="button"
            icon="pi pi-search"
            class="p-button-rounded black-icon"
            aria-label="Open search"
          ></button>
          <div *ngIf="showSearchBox" style="margin-right: 4px">
            <p-autoComplete
              [(ngModel)]="searchTxt"
              [suggestions]="newserachResults"
              minLength="1"
              (onSelect)="getSearchDetails($event)"
              (completeMethod)="search($event)"
            ></p-autoComplete>
            <i class="icon pi pi-times closeicon closeiconposition" (click)="openSearchBox()"></i>
          </div>
          <button
            (click)="navigateToHome()"
            pButton
            pRipple
            type="button"
            icon="pi pi-times"
            class="p-button-rounded black-icon"
            aria-label="Close map"
          ></button>
        </div>
      </div>
      <div id="ll-map"></div>
    </div>
  </div>
</div>

<p-overlayPanel #categoryPanel [dismissable]="true">
  <ng-template pTemplate>
    <div class="row">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="categoryOptions"></ng-container>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>

<ng-template #categoryOptions>
  <div>
    <div [innerHTML]="selectedContent"></div>
  </div>
  <div style="background-color: #00a7a6; color: #fff; width: 100%; display: flex; padding: 20px; font-weight: bold">
    <span><i class="icon-location"></i>{{ selectedCat.name | translate }}</span>
  </div>
  <div *ngFor="let category of categoryTypes; let i = index">
    <p-panel
      (click)="selectCategeory(category.id, i, category.name, category.src)"
      [toggleable]="true"
      [collapsed]="selectedCatKey !== category.id"
      toggler="header"
      expandIcon="fas fa-caret-down"
      collapseIcon="fas fa-caret-up"
    >
      <ng-template pTemplate="header">
        <div>
          <img src="{{ category.src }}" class="headerIcon" alt="headerIcon" />
          <span style="line-height: 30px" *ngIf="category.name != 'Airlines'">{{ category.name | translate }}</span>
          <span style="line-height: 30px" *ngIf="category.name == 'Airlines'">{{ 'Getting Around' | translate }}</span>
        </div>
      </ng-template>
      <div *ngFor="let key of subCatKeys; let ival = index">
        <div (click)="$event.stopPropagation()" class="p-field-checkbox">
          <p-radioButton
            inputId="{{ category.id }}-{{ key }}"
            name="{{ category.id }}"
            [value]="key"
            [(ngModel)]="selectedSubCatKey"
            (onClick)="showMarkers(key, subCat[key]); categoryPanel.hide()"
          ></p-radioButton>
          <label
            style="text-transform: capitalize; font-size: 14px"
            class="subcat-label mb-0"
            [class.label-active]="selectedSubCatKey === key"
            for="{{ category.id }}-{{ key }}"
          >
            <span>{{ getLabel(key) | translate }}</span>
            <span>{{ subCat[key].length }}</span>
          </label>
        </div>
      </div>
    </p-panel>
  </div>
</ng-template>
